import { Link } from 'react-router-dom';
import { Head } from 'vite-react-ssg';
import FooterSection from '../../components/FooterSection';
import { WA_NUMBER } from '../../constant/detail';

const relatedServices = [
  { label: 'Jasa Maintenance Kolam Renang Bali', to: '/jasa-maintenance-kolam-renang-bali' },
  { label: 'Jual Chemical Pool Bali', to: '/jual-chemical-pool-bali' },
  { label: 'Pasang Filter Kolam Renang Bali', to: '/pasang-filter-kolam-renang-bali' },
  { label: 'Jual Equipment Pool Bali', to: '/equipment-pool-bali' },
  { label: 'Konsultasi Kolam Renang Bali', to: '/konsultasi-kolam-renang-bali' },
];

const WA_MESSAGE = encodeURIComponent(
  'Hello, I would like to schedule a pool water test in Bali'
);

const TestkitWaterPool = () => {
  return (
    <>
      <Head>
        <title>Jasa Testkit Air Kolam Renang Bali | Uji Kualitas Air | SJT</title>
        <meta
          name="description"
          content="Jasa testkit air kolam renang Bali akurat. Analisis pH, klorin, alkalinitas dengan alat digital profesional. Laporan lengkap via WhatsApp. Konsultasi sekarang!"
        />
        <link rel="canonical" href="https://poolshopsuryajayateknik.com/jasa-testkit-air-kolam-bali" />
        <meta property="og:title" content="Jasa Testkit Air Kolam Renang Bali | Uji Kualitas Air | SJT" />
        <meta property="og:description" content="Jasa testkit air kolam renang Bali akurat. Analisis pH, klorin, alkalinitas dengan alat digital profesional. Laporan lengkap via WhatsApp." />
        <meta property="og:image" content="https://poolshopsuryajayateknik.com/img/blog/img-2.jpg" />
        <meta property="og:url" content="https://poolshopsuryajayateknik.com/jasa-testkit-air-kolam-bali" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Jasa Testkit Air Kolam Renang Bali | Uji Kualitas Air | SJT" />
        <meta name="twitter:description" content="Jasa testkit air kolam renang Bali akurat. Analisis pH, klorin, alkalinitas dengan alat digital profesional. Laporan lengkap via WhatsApp." />
      </Head>

      <main className="mt-16 bg-white text-gray-800">
        {/* Hero */}
        <section className="bg-tertiary text-white py-16 px-6 text-center">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
              Pool Water Testing Bali – Accurate Analysis &amp; Consultation
            </h1>
            <p className="text-lg text-primary/80 mb-8">
              Is your pool water safe to use? Unmonitored water quality can put
              swimmers at risk, from eye irritation and skin infections to
              respiratory issues. Suryajaya Teknik provides professional pool
              water quality testing in Bali using international-standard digital
              testing equipment. Get a full analysis report along with clear
              treatment recommendations to bring your pool water back to the
              ideal condition.
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary hover:opacity-90 text-tertiary font-semibold py-3 px-8 rounded-full text-lg transition"
            >
              Consultation via WhatsApp
            </a>
          </div>
        </section>

        {/* Why */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Why Pool Water Testing Is So Important
          </h2>
          <p className="mb-4 leading-relaxed">
            Pool water that looks clear is not necessarily safe or chemically
            balanced. Incorrect pH levels can damage skin, eyes, and even the
            pool structure itself over time. Too much chlorine causes
            irritation, while too little chlorine fails to kill harmful bacteria
            and viruses. In Bali, the tropical climate accelerates water quality
            changes, making regular testing essential for pool safety. With our
            professional testing service, you get accurate data that forms the
            basis for the right and efficient chemical treatment.
          </p>
          <p className="leading-relaxed">
            Our pool water testing covers all the key parameters that determine
            water quality and safety. Our analysis team uses digital photometers
            and professional test kits that are far more accurate than regular
            test strips. Every test result comes with an easy-to-read
            interpretation and action recommendations, even for pool owners with
            no technical background. We also provide follow-up consultation to
            help you understand how to maintain safe water parameters on your
            own. Customer safety and trust is our top priority in every service
            we provide.
          </p>
        </section>

        {/* Parameters */}
        <section className="bg-primary/10 py-14 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-tertiary mb-6">
              Parameters We Test
            </h2>
            <div className="grid md:grid-cols-2 gap-5">
              {[
                {
                  name: 'pH Level',
                  desc: 'Measures the acidity/alkalinity of the water. Ideal range is 7.2-7.6 for swimmer comfort and chlorine effectiveness.',
                },
                {
                  name: 'Chlorine Test',
                  desc: 'Measures active chlorine available to kill bacteria. Ideal range is 1-3 ppm.',
                },
              
              ].map((param, i) => (
                <div
                  key={i}
                  className="bg-white border border-primary rounded-xl p-5 shadow-sm"
                >
                  <h3 className="font-semibold text-tertiary mb-2">
                    {param.name}
                  </h3>
                  <p className="text-gray-600 text-sm">{param.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Us */}
        <section className="max-w-4xl mx-auto py-14 px-6">
          <h2 className="text-2xl font-bold text-tertiary mb-4">
            Why Choose Our Testing Service?
          </h2>
          <ul className="space-y-3">
            {[
              'Complete analysis results with easy-to-understand interpretation',
              'Recommended chemical dosage based on actual test results',
              'Digital report sent via WhatsApp after testing',
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="text-tertiary font-bold mt-0.5">✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* CTA */}
        <section className="bg-tertiary text-white py-16 px-6 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold mb-4">
              Schedule Your Pool Water Test Today
            </h2>
            <p className="text-primary/80 mb-8">
              Make sure your pool is safe and comfortable with a professional
              water quality test. Contact us now to schedule a visit and get a
              complete and accurate analysis of your pool water.
            </p>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary hover:opacity-90 text-tertiary font-semibold py-3 px-10 rounded-full text-lg transition"
            >
              Contact Us via WhatsApp
            </a>
          </div>
        </section>

        {/* Related Services */}
        <section className="max-w-4xl mx-auto py-10 px-6">
          <h2 className="text-lg font-bold text-tertiary mb-4">Layanan Lainnya</h2>
          <div className="flex flex-wrap gap-3">
            {relatedServices.map(({ label, to }) => (
              <Link key={to} to={to} className="text-sm font-medium text-primary border border-primary/40 px-4 py-2 rounded-full hover:bg-primary/10 transition">
                {label}
              </Link>
            ))}
          </div>
        </section>

        <FooterSection />
      </main>
    </>
  );
};

export default TestkitWaterPool;
